import CtaLink from '@/pages/home/components/CtaLink';
import Reveal from '@/components/base/Reveal';

export default function FinalCta() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-primary-500/20 bg-gradient-to-br from-background-200 to-background-100 p-10 md:p-16 text-center">
            <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-primary-500/10 blur-[120px]" />

            <div className="relative">
              <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
                Ready to Talk?
              </span>
              <h2 className="mt-6 font-heading font-bold text-3xl md:text-5xl text-foreground-950">
                Build a Smarter Marketing System for Your Business.
              </h2>
              <p className="mt-5 max-w-2xl mx-auto text-foreground-600 leading-relaxed">
                Whether you want a team to execute the marketing for you or need
                Josh to work alongside your existing team, the first step is
                understanding where your business is now and where you want to
                go.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
                <CtaLink>Apply to Work With Me</CtaLink>
              </div>
              <p className="mt-6 text-sm text-foreground-600">
                DFY Marketing &bull; DWY Consulting &bull; Established
                Businesses
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
